export default __webpack_public_path__ + "static/media/DummyMultiPdf.49ee538b.pdf";